/* web/app/components/layout/main/header/navbar-mobile/top/navbar-mobile-top.scss */
ul.nav {
  border-bottom: 1px solid #ccc;
}
.nav-item {
  border-right: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
  margin-left: -1px;
  padding: 11px 0 8px;
  color: gray;
}
.nav-item ::ng-deep .btn-collapse i,
.nav-item ::ng-deep user-login-button i,
.nav-item ::ng-deep main-header-user-details i,
.nav-item ::ng-deep .search-wrap i,
.nav-item ::ng-deep main-header-cart a i,
.nav-item ::ng-deep main-header-media-cart a i {
  font-size: 26px;
  color: #888;
}
.nav-item ::ng-deep .btn-collapse .icon-text,
.nav-item ::ng-deep user-login-button .icon-text,
.nav-item ::ng-deep main-header-user-details .icon-text,
.nav-item ::ng-deep .search-wrap .icon-text,
.nav-item ::ng-deep main-header-cart a .icon-text,
.nav-item ::ng-deep main-header-media-cart a .icon-text {
  margin-top: 4px;
  font-size: 12px;
}
.nav-item button.btn-collapse {
  font-size: 31px;
}
.nav-item .fa-shopping-cart .badge {
  color: #f2f2f2 !important;
  background: #434343 !important;
  border-color: #fff !important;
  padding: 2px 5px !important;
  font-family: sans-serif;
  border-radius: 10px;
  line-height: 1;
}
.mobile-links-items .user-details-wrap .icon-text {
  width: 15vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
/*# sourceMappingURL=navbar-mobile-top.css.map */
